import pickLib from 'lodash.pick';

export default function pick(...args) {
    return pickLib.apply(this, args);
}
